import React from "react";
import { MessageCircle } from "lucide-react";
import { Chat } from "../../types/conversations";

interface SupportChatListItemProps {
  chat: Chat;
  isSelected: boolean;
  onClick: () => void;
}

export const SupportChatListItem: React.FC<SupportChatListItemProps> = ({
  chat,
  isSelected,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={`flex items-center gap-3 px-3 py-3 cursor-pointer border-b-2 border-purple-100 dark:border-purple-900/40 transition active:bg-purple-50 dark:active:bg-purple-900/20 md:px-4 ${
        isSelected
          ? "bg-purple-50 dark:bg-purple-900/20"
          : "hover:bg-purple-50/60 dark:hover:bg-purple-900/10 bg-white dark:bg-gray-800"
      }`}
    >
      {/* Avatar */}
      <div className="relative flex-shrink-0">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 to-purple-700 flex items-center justify-center">
          <MessageCircle className="w-6 h-6 text-white" />
        </div>
        {/* Indicador online */}
        <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-400 rounded-full border-2 border-white dark:border-gray-800" />
      </div>

      {/* Conteúdo */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1 gap-2">
          <div className="flex items-center gap-1.5 min-w-0 flex-1">
            <h3 className="font-semibold text-sm text-gray-900 dark:text-white truncate md:text-base">
              {chat.name}
            </h3>
            <span className="flex-shrink-0 text-[10px] rounded bg-purple-500 text-white font-medium px-1.5 py-0.5 md:text-xs md:px-2">
              Suporte
            </span>
          </div>
          <span className="text-[11px] text-green-500 font-medium flex-shrink-0 md:text-xs">
            Online
          </span>
        </div>
        <p className="text-[11px] text-gray-500 dark:text-gray-400 truncate md:text-xs">
          {chat.lastMessage}
        </p>
      </div>
    </div>
  );
};
